import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchCompletedTask, fetchMetaData } from "../../../service/Task";
import { FaArrowLeft } from "react-icons/fa6";
import AppContext from "../../../context/AppContext";
import { Spinner } from "../../../Spinner";
import AWS from "aws-sdk";
import { updateCompletedTask } from "../../../service/Task";
import { deleteS3Object, uploadFileToS3 } from "../../../service/S3Bucket";
import { toast } from "react-toastify";
import translations from "../../common/Translations";
import { fetchWorkflowData } from "../../../service/workflow";
import { GrPowerReset } from "react-icons/gr";
import Modal from "../../../pages/task/Modal"
import ExitModal from "../../../pages/workflow/ExitModal/ExitModal";

export default function UpdateTask() {
  const { taskId } = useParams();
  const [taskDetail, setTaskDetail] = useState([]);
  const { theme, langMode, workflowId } = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updatedFiles, setUpdatedFiles] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [fieldValues, setFieldValues] = useState({});
  const [metaData, setMetaData] = useState([]);
  const [activeRadioInputKey, setActiveRadioInputKey] = useState(null);
  const [displayFields, setDisplayFields] = useState([]);
  // const initialTaskDetailRef = useRef([...taskDetail] || []);
  const initialTaskDetailRef = useRef(taskDetail);
  const initialFieldValuesRef = useRef({ ...fieldValues });
  const [open, setOpen] = useState(false)
  const [img, setImg] = useState('')
  const [formKey, setFormKey] = useState(Date.now());
  const [exitModal, setExitModal] = useState(false);
  const [nextPath, setNextPath] = useState(null);

  const handleOpenModal = (img) => {
    setOpen(true)
    setImg(img)
  }

  const getValueOrInputs = (data) => {
    const { value, allInputValues } = data || {};
  
    // If the value not exists, return it
    if (!value) {
      return;
    }
    
    // If allInputValues exists, extract inputKey from the array
    if (allInputValues && allInputValues.length > 0) {
      const inputObject = allInputValues.find(item => item.inputValue === value ? item?.inputKey : "");
      return inputObject; // Return an object containing the inputKeys array
    }
  
    return {};
  };

  // Function to filter dragItems based on the inputKey
const getFilteredDragItems = (dragItems, inputKey) => {
  return dragItems?.filter(item => item?.radioId === inputKey?.inputKey) || [];
};

// Function to process dragItems and return their mapped values
const processDragItems = (filteredDragItems) => {
  return filteredDragItems?.map(item => getValueOrInputs(item));
};
// Empty dependency array ensures this runs only on unmount

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      setExitModal(true);
      e.returnValue = "";
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    const handlePopState = (e) => {
      e.preventDefault();
      setExitModal(true);
      e.returnValue = "";
      e.returnValue = "";
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    const getTaskData = async () => {
      try {
        const taskData = await fetchCompletedTask(taskId);
        const fieldList = taskData.body?.value?.fieldList
        || [];
        const dragItems = taskData.body?.value?.dragItems || [];
        const result = (fieldList || [])?.map(item => getValueOrInputs(item));
        const getInputKey = result?.find((item) => item?.inputKey)

        const filteredDragItems = getFilteredDragItems(dragItems, getInputKey);

        let allFilteredItems = [...filteredDragItems]; // Final collection to show
        let visitedInputKeys = new Set(); // Avoid duplicate matching

        let shouldRepeat = true;

        while (shouldRepeat) {
          shouldRepeat = false;

          // Only check new ones with allInputValues
          const newItems = allFilteredItems.filter(
            item => Array.isArray(item.allInputValues)
          );

          for (const item of newItems) {
            // Skip if we've already processed this inputKey
            const key = `${item.uniqueKey}-${item.value}`;
            if (visitedInputKeys.has(key)) continue;

            const matchingInput = item.allInputValues.find(
              input => input.inputValue === item.value
            );

            if (matchingInput?.inputKey) {
              visitedInputKeys.add(key);

              const matched = dragItems.filter(
                d => d.radioId === matchingInput.inputKey
              );

              const newMatches = matched.filter(
                m => !allFilteredItems.find(existing => existing.uniqueKey === m.uniqueKey)
              );

              if (newMatches.length) {
                allFilteredItems.push(...newMatches);
                shouldRepeat = true; // Trigger another loop
              }
            }
          }
        }

        // Process values for dragItems
        // const isPresentInAllInputValues = processDragItems(filteredDragItems);
        // const getIsPresentInAllInputValuesInputKey = isPresentInAllInputValues?.find(item => item?.inputKey);
        // // Get response based on matching inputKey
        // const response = getFilteredDragItems(fieldList, getIsPresentInAllInputValuesInputKey);

        // Update state with the processed task details
        // setTaskDetail(fieldList)
        // setTaskDetail([
        //   ...fieldList,
        //   ...filteredDragItems,
        //   ...response
        // ]);
        // setMetaData(dragItems || []);
        setTaskDetail([...fieldList, ...allFilteredItems]);
        setMetaData(dragItems || []);
        // Store initial values only if empty (prevents overwriting on re-renders)
        if (!initialTaskDetailRef.current.length) {
          // initialTaskDetailRef.current = [...fieldList];
          // initialTaskDetailRef.current = [
          //   ...fieldList,
          //   ...filteredDragItems,
          //   ...response];
            initialTaskDetailRef.current = [...fieldList, ...allFilteredItems];
        }

        // const initialValues = fieldList?.fieldsMetadata?.reduce((acc, field) => {
        //   acc[field.uniqueKey] = field.defaultValue || "";
        //   return acc;
        // }, {});
        const initialValues = fieldList?.reduce((acc, field) => {
          acc[field.uniqueKey] = field.defaultValue || "";
          return acc;
        }, {});

        setFieldValues(initialValues);

        if (Object.keys(initialFieldValuesRef.current).length === 0) {
          initialFieldValuesRef.current = { ...initialValues };
        }
      } catch (error) {
        console.error("Error fetching completed task:", error);
        // setError("Failed to load task details.");
      } finally {
        setLoading(false);
      }
    };

    if (taskId) {
      getTaskData();
    }
  }, [taskId]);


  const handleFileChange = (fieldKey, event) => {
    const file = event.target.files[0];
    if (file) {
      setUpdatedFiles((prevFiles) => ({
        ...prevFiles,
        [fieldKey]: file,
      }));
    }
  };

  const handleChange = (fieldKey, event) => {
    setFieldValues((prevValues) => ({
      ...prevValues,
      [fieldKey]: event.target.value,
    }));
  };

  // const handleRadioChange = (fieldKey, event) => {
  //   const selectedValue = event.target.value;

  //   // Update field values for radio selection
  //   setFieldValues((prevValues) => ({
  //     ...prevValues,
  //     [fieldKey]: selectedValue,
  //   }));

  //   // Find the inputKey corresponding to the selected radio value
  //   const selectedRadio = metaData.find(meta => 
  //     meta.fieldType === "radio" && meta.allInputValues?.some(input => input.inputValue === selectedValue)
  //   );

  //   if (selectedRadio) {
  //     const selectedInputKey = selectedRadio.allInputValues.find(input => input.inputValue === selectedValue)?.inputKey;

  //     if (selectedInputKey) {
  //       // Find all fields where radioId matches the selected inputKey
  //       const dependentFields = metaData.filter(meta => meta.radioId === selectedInputKey);
  //       console.log(dependentFields)
  //       setFieldValues((prevValues) => {
  //         const updatedValues = { ...prevValues };
  //         dependentFields.forEach(field => {
  //           updatedValues[field.uniqueKey] = ""; // Show these fields by setting them to empty or default
  //         });
  //         return updatedValues;
  //       });
  //     }
  //   }
  // };

  //   const handleRadioChange = (fieldKey, event) => {
  //     const selectedValue = event.target.value;

  //     // Update the selected radio field value immediately
  //     setFieldValues((prevValues) => {
  //         const updatedValues = {
  //             ...prevValues,
  //             [fieldKey]: selectedValue,
  //         };
  //         console.log("Updated Field Values:", updatedValues);
  //         return updatedValues;
  //     });

  //     // Find the selected radio field metadata
  //     const selectedRadio = metaData.find((meta) => meta.uniqueKey === fieldKey);
  //     if (!selectedRadio) return; // Exit if not found

  //     const selectedInputKey = selectedRadio.allInputValues.find(
  //         (input) => input.inputValue === selectedValue
  //     )?.inputKey;

  //     if (!selectedInputKey) return; // Allow selection even if no child exists

  //     setActiveRadioInputKey(selectedInputKey);

  //     // Recursive function to find all dependent fields, including grandchildren
  //     const getAllDependentFields = (parentKey) => {
  //         const children = metaData.filter((meta) => meta.radioId === parentKey);
  //         return children.reduce(
  //             (acc, child) => [...acc, child, ...getAllDependentFields(child.uniqueKey)],
  //             []
  //         );
  //     };

  //     // Get all dependent fields (children + grandchildren) of the selected input key
  //     const newDependentFields = getAllDependentFields(selectedInputKey);

  //     // Get all siblings of the current radio field (same parent)
  //     const siblingFields = metaData.filter(
  //         (meta) => meta.radioId === selectedRadio.radioId && meta.uniqueKey !== fieldKey
  //     );

  //     // Identify independent fields (fields without a radioId)
  //     const independentFields = metaData.filter((meta) => !meta.radioId);

  //     // Preserve the hierarchy while updating taskDetail
  //     setTaskDetail((prevTaskDetail) => {
  //         // Keep independent fields, the selected radio field, its siblings, and dependent fields
  //         const remainingFields = prevTaskDetail.filter(
  //             (field) =>
  //                 independentFields.some((ind) => ind.uniqueKey === field.uniqueKey) ||
  //                 siblingFields.some((sibling) => sibling.uniqueKey === field.uniqueKey) ||
  //                 newDependentFields.some((dep) => dep.uniqueKey === field.uniqueKey) ||
  //                 field.uniqueKey === fieldKey
  //         );

  //         // Ensure child and grandchild fields stay in the correct order
  //         const radioIndex = remainingFields.findIndex((field) => field.uniqueKey === fieldKey);
  //         if (radioIndex !== -1) {
  //             remainingFields.splice(radioIndex + 1, 0, ...newDependentFields);
  //         } else {
  //             remainingFields.push(...newDependentFields);
  //         }

  //         return remainingFields;
  //     });

  //     // Update field values but keep selected, siblings, and their children
  //     setFieldValues((prevValues) => {
  //         const updatedValues = { ...prevValues };

  //         Object.keys(updatedValues).forEach((key) => {
  //             if (
  //                 !newDependentFields.some((field) => field.uniqueKey === key) &&
  //                 !siblingFields.some((sibling) => sibling.uniqueKey === key) &&
  //                 key !== fieldKey // Keep the selected radio field's value
  //             ) {
  //                 delete updatedValues[key];
  //             }
  //         });

  //         // Initialize new dependent fields with default values
  //         newDependentFields.forEach((field) => {
  //             if (!(field.uniqueKey in updatedValues)) {
  //                 updatedValues[field.uniqueKey] = ""; // Default empty value
  //             }
  //         });

  //         return updatedValues;
  //     });
  // };


  // const handleRadioChange = (fieldKey, event) => {
  //   const selectedValue = event.target.value;
  //   setFieldValues((prevValues) => {
  //     const updatedValues = {
  //       ...prevValues,
  //       [fieldKey]: selectedValue,
  //     };
  //     console.log("Updated Field Values:", updatedValues);
  //     return updatedValues;
  //   });

  //   setActiveRadioInputKey(selectedValue);

  //   const selectedRadio = metaData.find((meta) => meta.uniqueKey === fieldKey);
  //   if (!selectedRadio) return; // Exit if not found

  //   const selectedInputKey = selectedRadio.allInputValues.find(
  //     (input) => input.inputValue === selectedValue
  //   )?.inputKey;

  //   if (!selectedInputKey) return; // Allow selection even if no child exists

  //   setActiveRadioInputKey(selectedInputKey);

  //   // const getAllDependentFields = (parentKey) => {
  //   //   const children = metaData.filter((meta) => meta.radioId === parentKey);
  //   //   return children.reduce(
  //   //     (acc, child) => [...acc, child, ...getAllDependentFields(child.uniqueKey)],
  //   //     []
  //   //   );
  //   // };

  //   const getAllDependentFields = (parentKey) => {
  //     const children = metaData.filter((meta) => meta.radioId === parentKey);
  //     return children.flatMap((child) => [child, ...getAllDependentFields(child.uniqueKey)]);
  //   };


  //   const newDependentFields = getAllDependentFields(selectedInputKey);
  //   const siblingFields = metaData.filter(
  //     (meta) => meta.radioId === selectedRadio.radioId && meta.uniqueKey !== fieldKey
  //   );
  //   const independentFields = metaData.filter((meta) => !meta.radioId);

  //   // Preserve the hierarchy while updating taskDetail
  //   setTaskDetail((prevTaskDetail) => {
  //     const remainingFields = prevTaskDetail.filter(
  //       (field) =>
  //         independentFields.some((ind) => ind.uniqueKey === field.uniqueKey) ||
  //         siblingFields.some((sibling) => sibling.uniqueKey === field.uniqueKey) ||
  //         newDependentFields.some((dep) => dep.uniqueKey === field.uniqueKey) ||
  //         field.uniqueKey === fieldKey
  //     );

  //     const radioIndex = remainingFields.findIndex((field) => field.uniqueKey === fieldKey);
  //     if (radioIndex !== -1) {
  //       remainingFields.splice(radioIndex + 1, 0, ...newDependentFields);
  //     } else {
  //       remainingFields.push(...newDependentFields);
  //     }

  //     return remainingFields;
  //   });

  //   setFieldValues((prevValues) => {
  //     const updatedValues = { ...prevValues };
  //     Object.keys(updatedValues).forEach((key) => {
  //       if (
  //         !newDependentFields.some((field) => field.uniqueKey === key) &&
  //         !siblingFields.some((sibling) => sibling.uniqueKey === key) &&
  //         key !== fieldKey // Keep the selected radio field's value
  //       ) {
  //         delete updatedValues[key];
  //       }
  //     });

  //     newDependentFields.forEach((field) => {
  //       if (!(field.uniqueKey in updatedValues)) {
  //         updatedValues[field.uniqueKey] = ""; // Default empty value
  //       }
  //     });

  //     return updatedValues;
  //   });
  // };


  const getAllAncestorSiblings = (currentKey, collected = [], parents = []) => {
    const currentMeta = metaData.find((meta) => meta.uniqueKey === currentKey);
    if (!currentMeta || !currentMeta.radioId) return {collected, parents};
  
    const parentKey = currentMeta.radioId;
    // Step 1: Get sibling fields from metaData
    const siblingFields = metaData.filter(
      (meta) => meta.radioId === parentKey && meta.uniqueKey !== currentKey
    );

    // Add current level siblings to collection
    collected = [...collected, ...siblingFields];

    // Step 2: See if parentKey (radioId) exists in inputKey of allInputValues
    let parentMeta = null;
    for (const meta of metaData) {
      const match = meta.allInputValues?.find(input => input.inputKey === parentKey);
      if (match) {
        parentMeta = meta;
        break;
      }
    }
    // Step 3: Recurse if nextKey was found
    if (parentMeta) {
      parents.push(parentMeta);
      return getAllAncestorSiblings(parentMeta.uniqueKey, collected, parents);
    }
    return { collected, parents };
  };

 const checkDependentValue = (item, metaData, updatedFields) => {
  if (item?.allInputValues && item?.allInputValues.length > 0) {
    const result = getValueOrInputs(item);
    const inputKey = result?.inputKey;

    if (inputKey) {
      const dependentFields = metaData.filter(
        (metaItem) => metaItem?.radioId === inputKey
      );

      dependentFields.forEach((childItem) => {
        const isPresent = updatedFields.some(
          (field) => field?.id === childItem?.id
        );

        if (!isPresent) {
          updatedFields.push(childItem);
          // Recurse if child is also a radio
          if (childItem?.fieldType === "radio") {
            checkDependentValue(childItem, metaData, updatedFields);
          }
        }
      });
    }
  }
};


  const handleRadioChange = (fieldKey, event) => {
    const selectedValue = event.target.value;

    setFieldValues((prevValues) => ({
      ...prevValues,
      [fieldKey]: selectedValue,
    }));

    const selectedRadio = metaData.find((meta) => meta.uniqueKey === fieldKey);
    if (!selectedRadio) return; // Exit if radio button metadata is missing
    const getAllDependentFields = (parentKey) => {
      const children = metaData.filter((meta) => meta.radioId === parentKey);
      return children.flatMap((child) => [child, ...getAllDependentFields(child.uniqueKey)]);
    };

    const selectedInputKey = selectedRadio.allInputValues.find(
      (input) => input.inputValue === selectedValue
    )?.inputKey;
    if (!selectedInputKey) return; // Allow selection even if no child exists

    // Fetch all children, grandchildren, etc., recursively
    const newDependentFields = getAllDependentFields(selectedInputKey);
    
    // const siblingFields = metaData.filter(
    //   (meta) => meta.radioId === selectedRadio.radioId && meta.uniqueKey !== fieldKey
    // );
    
    const { collected: allParentSiblings, parents: parentData }  = getAllAncestorSiblings(fieldKey);

    // const independentFields = metaData.filter((meta) => !meta.radioId);
    const independentFields = [
      ...metaData.filter((meta) => !meta.radioId),
      ...parentData
    ];

    // Preserve the hierarchy while updating `taskDetail`
    setTaskDetail((prevTaskDetail) => {
      const remainingFields = prevTaskDetail.filter(
        (field) =>
          independentFields.some((ind) => ind?.uniqueKey === field?.uniqueKey) ||
          // siblingFields.some((sibling) => sibling?.uniqueKey === field?.uniqueKey) ||
          newDependentFields.some((dep) => dep?.uniqueKey === field?.uniqueKey) ||
          (allParentSiblings ?? []).some((ps) => ps?.uniqueKey === field?.uniqueKey) ||
          field?.uniqueKey === fieldKey
      );

      // Ensure hierarchical insertion
      newDependentFields.forEach((field) => {
        if (!remainingFields.some((existing) => existing?.uniqueKey === field?.uniqueKey)) {
          remainingFields.push(field);
        }
      });
      
      const updatedFields = remainingFields?.map((item) => 
        item?.uniqueKey === fieldKey 
          ? { ...item, value: selectedValue }  // Update value if condition is match
          : item  // Return the item unchanged if condition is not met
      );

      updatedFields.forEach((item) => {
      checkDependentValue(item, metaData, updatedFields);
      });
      return updatedFields;
    });

    // Ensure all dependent fields are properly managed
    setFieldValues((prevValues) => {
      const updatedValues = { ...prevValues };

      Object.keys(updatedValues).forEach((key) => {
        if (
          !newDependentFields.some((field) => field.uniqueKey === key) &&
          // !siblingFields.some((sibling) => sibling.uniqueKey === key) &&
          key !== fieldKey // Keep the selected radio field's value
        ) {
          delete updatedValues[key];
        }
      });

      newDependentFields.forEach((field) => {
        if (!(field.uniqueKey in updatedValues)) {
          updatedValues[field.uniqueKey] = ""; // Default empty value
        }
      });

      return updatedValues;
    });
  };

  const handleSubmit = async () => {
    const fieldsData = { taskId };
    setIsLoading(true);

    for (const field of taskDetail) {
      if (field?.fieldType === "file" && updatedFiles[field.uniqueKey]) {
      
        try {
          const uploadedFilePath = await uploadFileToS3(
            updatedFiles[field.uniqueKey]
          );
          fieldsData[field.uniqueKey] = uploadedFilePath;
        } catch (uploadError) {
          console.error(`Failed to upload file:`, uploadError);
          toast.error("Error uploading file. Please try again.");
          return;
        }
      } else {
        fieldsData[field?.uniqueKey] =
          fieldValues[field?.uniqueKey] || field?.value;
      }
    }
    try {
      const response = await updateCompletedTask(fieldsData);
      if (response.header.code === 600) {
        toast.success(response.body.value);
        setExitModal(false);
        setIsLoading(false);
        if (nextPath) {
          navigate(nextPath); // go to originally intended route
          setNextPath(null);
        } else {
          navigate("/task-manage");
        }
        setIsLoading(false);
      } else {
        toast.error(response.body.value);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Failed to update task:", error);
      toast.error("Error updating task. Please try again.");
      setIsLoading(false);
    }
  };

  const hasUserChangedAnything = (taskDetail, fieldValues, updatedFiles) => {
    return taskDetail?.some((field) => {
      if (!field || !field.uniqueKey) return false;
  
      const { uniqueKey, value, fieldType } = field;
  
      if (fieldType === "file") {
        const updated = updatedFiles[uniqueKey];
        return value === null && updated && Object.keys(updated).length > 0;
      } else {
        const original = String(value ?? "").trim();
        const current = String(fieldValues[uniqueKey] ?? "").trim();
        return original !== current;
      }
    });
  };
  

  useEffect(() => {
    const changed = hasUserChangedAnything(taskDetail, fieldValues, updatedFiles);
    const handleBlockNavigation = async(e) => {
      console.log("Mismatches found: AAAA", changed);
      // if (changed) {
        console.log("⚠️ User has unsaved changes.");
        setExitModal(true);
        setNextPath(e.detail?.nextPath); // Save target route for later
      // } else {
      //   console.log("✅ No changes detected, allow navigation.");
      //   setExitModal(false);
      //   navigate(e.detail?.nextPath); 
      //   // window.removeEventListener("blockNavigation", handleBlockNavigation);
      // }

     
    };
  
    window.addEventListener("blockNavigation", handleBlockNavigation);
  
    return () => {
      window.removeEventListener("blockNavigation", handleBlockNavigation);
    };
  }, []);

  const renderField = (field, index) => {
    switch (field?.fieldType) {
      case "text":
      case "email":
      case "number":
      case "date":
      case "time":
      case "scan":
        return (
          <div key={field.uniqueKey} className="mb-4">
            <label className="block text-sm font-medium text-gray-800">
              {index + 1}. {field.fieldName} {/* Add the index number here */}
            </label>
            <input
              type={field?.fieldType}
              defaultValue={fieldValues[field.uniqueKey] || field.value}
              key={field.uniqueKey}
              onChange={(e) => handleChange(field.uniqueKey, e)}
              className="border border-gray-300 p-2 mt-1 w-full rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
            />
          </div>
        );
      case "textarea":
        return (
          <div key={field.uniqueKey} className="mb-4">
            <label className="block text-sm font-medium text-gray-800">
              {index + 1}. {field.fieldName} {/* Add the index number here */}
            </label>
            <textarea
              defaultValue={fieldValues[field.uniqueKey] || field.value}
              key={field.uniqueKey}
              onChange={(e) => handleChange(field.uniqueKey, e)}
              className="border border-gray-300 p-2 mt-1 w-full rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
              rows="4"
            ></textarea>
          </div>
        );
      case "radio":
        return (
          <div key={field.uniqueKey} className="mb-4">
            <label className="block text-sm font-medium text-gray-800">
              {field.fieldName}
            </label>
            <div className="mt-2">
              {field.allInputValues?.map((option) => (
                <label key={option.inputKey} className="flex items-center space-x-2">
                  <input
                    type="radio"
                    name={field.uniqueKey}
                    value={option.inputValue}
                    checked={fieldValues[field.uniqueKey] === option.inputValue || (!fieldValues[field.uniqueKey] && field.value === option.inputValue)}
                    onChange={(e) => handleRadioChange(field.uniqueKey, e)}
                    className="h-4 w-4"
                  />
                  <span>{option.inputValue}</span>
                </label>
              ))}
            </div>
          </div>
        );


      case "checkbox":
        return (
          <div key={field.uniqueKey} className="mb-4 flex items-center">
            <input
              type="checkbox"
              defaultChecked={field.value === "true" || field.value === true}
              key={field.uniqueKey}
              className="mr-2 focus:ring-indigo-500"
              disabled
            />
            <label className="text-sm text-gray-700">
              {index + 1}. {field.fieldName} {/* Add the index number here */}
            </label>
          </div>
        );
      case "file":
        return (
          <div key={field.uniqueKey} className="mb-4">
            <label className="block text-sm font-medium text-gray-800">
              {index + 1}. {field.fieldName} {/* Add the index number here */}
            </label>
            {field.value ? (
              <div className="mt-2" >
                {field.value.match(/\.(jpeg|jpg|gif|png|svg|webp)$/i) ? (
                  <div className="w-32 h-32 border border-gray-300 rounded-lg overflow-hidden">
                    <img
                      src={field.value}
                      alt="Uploaded file preview"
                      className="w-full h-full object-cover"
                      onClick={() => handleOpenModal(field.value)}
                    />
                  </div>
                ) : (
                  <a
                    href={field.value}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-indigo-500 underline hover:text-indigo-700 mb-2 block"
                  >
                    View Existing File
                  </a>
                )}
              </div>
            ) : (
              <p className="text-sm text-gray-500 mb-2">No file uploaded.</p>
            )}
            <input
              type="file"
              onChange={(e) => handleFileChange(field.uniqueKey, e)}
              className="border border-gray-300  mt-1 w-full rounded-lg focus:ring-2 focus:ring-indigo-500"
            />
          </div>
        );

      case "select":
        return (
          <div key={field.uniqueKey} className="mb-4">
            <label className="block text-sm font-medium text-gray-800">
              {index + 1}. {field.fieldName}
            </label>
            <select
              value={field.value || ""}
              disabled
              className="border border-gray-300 p-2 mt-1 w-full rounded-lg bg-gray-100 focus:outline-none"
            >
              {Array.isArray(field.allInputValues) && field.allInputValues.length > 0 ? (
                field.allInputValues.map((option) => (
                  <option key={option.id} value={option.inputValue}>
                    {option.inputValue}
                  </option>
                ))
              ) : (
                <option value="" disabled>
                  No options available
                </option>
              )}
            </select>
          </div>
        );

    }
  };

  if (loading) {
    return <div className="text-center p-4">Loading task details...</div>;
  }

  if (error) {
    return <div className="text-center p-4 text-red-500">{error}</div>;
  }
  const handleGoBack = () => {
    navigate("/task-manage");
    return (
      <div>
        <Spinner />
      </div>
    );
  };

  const handleReset = () => {
    setTaskDetail([...initialTaskDetailRef.current]); // Reset task details
    setFieldValues({ ...initialFieldValuesRef.current }); // Reset field values
    setUpdatedFiles({}); // Clear uploaded files
    setFormKey(Date.now()); // Force re-render of form fields
    toast.info("Task details have been reset to default.");
  };

  const navigateToWorkflow = () => {
    handleSubmit()
  };

  const handleExitModal = () => {
      setExitModal(true);
  };

  return (
    <div className="">
      {isLoading && <Spinner />}
      <div className="flex justify-between">
        <div className="inline-flex">
          <div
            onClick={handleExitModal}
            className={`p-2 rounded-full border cursor-pointer w-8 m-3 ml-5
        ${theme === "dark"
                ? "bg-gray-800 border-gray-600 hover:bg-gray-700"
                : ""
              } 
        ${theme === "high-contrast"
                ? "high-contrast border border-gray-600"
                : ""
              } 
        ${theme !== "dark" && theme !== "high-contrast"
                ? "border-gray-400 hover:bg-gray-200"
                : ""
              } `}
          >
            <FaArrowLeft
              className={`h-3 w-3 ${theme === "dark"
                ? "text-white"
                : theme === "high-contrast"
                  ? "text-black"
                  : "text-gray-700"
                }`}
            />
          </div>
          <h2 className="text-md font-semibold mt-3 ">{translations[langMode].updatetaskdetail}</h2>
        </div>
        <div className="">
          <button onClick={handleReset} className=" mt-5 text-sm text-white bg-green-600 px-2 py-1 rounded-md inline-flex gap-2"><GrPowerReset size={20} className="" /> Reset</button>
        </div>
      </div>
      <div className="p-5">
        <div className="max-w-full  rounded-md">
          {taskDetail.length === 0 ? (
            <div className="text-center text-gray-500">No data available</div>
          ) : (
            <form key={formKey} className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
              {Array.isArray(taskDetail) && taskDetail?.map((field, index) => renderField(field, index))}
            </form>
          )}
        </div>
        <div className="flex gap-5 justify-end">
          <button
            type="submit"
            onClick={handleSubmit}
            className=" bg-blue-800 text-white text-xs py-2 px-4 rounded-md hover:bg-blue-600 transition duration-300"
          >
            {translations[langMode].save}
          </button>
          <button
            onClick={handleGoBack}
            className=" bg-black text-white text-xs py-2 px-4 rounded-md  transition duration-300"
          >
            {translations[langMode].cancel}
          </button>
        </div>
      </div>
      {open && <Modal open={open} setOpen={setOpen} img={img} />
      }

      {exitModal && (
        <ExitModal
          setExitModal={setExitModal}
          exitModal={exitModal}
          navigateToWorkflow={navigateToWorkflow}
          showMsg={"Do you really want to leave? This action will you save or discard ?"}
          cancel_btn={"Discard"}
          save_btn={"Save"}
          onCancel={() => {setExitModal(false);nextPath ? navigate(nextPath): navigate("/task-manage")}}
        />
      )}
    </div>
  );
}
